import { captureError, captureMessage, addBreadcrumb } from '@/sentry.config';

const logger = {
  // Error log
  error(error, payload) {
    captureError(error, payload);
  },

  // Message log
  message(message, payload) {
    captureMessage(message, payload);
  },

  // Add Breadcrumb
  addBreadcrumb(message, category, level) {
    addBreadcrumb(message, category, level);
  },
};

export default logger;
